import { ReactElement } from 'react';
import classnames from 'classnames';
import { MDCListDivider } from '../List/List';
import { dividerPropTypes } from './_types';
import { CSS_CLASSES } from './_constants';

import './Divider.scss';

/**
 * Functional component for dividing HTML content with a thematic break. Operates as a semantic horizontal rule.
 * @param {Object} props JSX attributes passed to component.
 * @returns {ReactElement} rendered component.
 */
const divider = ({ className, ...props }) => (
	<MDCListDivider
		className={classnames(CSS_CLASSES.DIVIDER, className)}
		tag='hr'
		{...props}
	/>
);

divider.propTypes = dividerPropTypes;

export { divider };
